import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const adminApi = createApi({
  reducerPath: 'adminApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Admin'],
  endpoints: (builder) => ({
    getUsers: builder.query<unknown[], void>({
      query: () => 'admin/users',
      providesTags: ['Admin'],
    }),
    getRoles: builder.query<unknown[], void>({
      query: () => 'admin/roles',
      providesTags: ['Admin'],
    }),
  }),
});

export const { useGetUsersQuery, useGetRolesQuery } = adminApi;
